@if (isUnified) {
  <!-- Unified Code hero (criterion 7 image type, criterion 38 feedback/motion): accessible carousel with
       indicators as buttons, a pause/play control and a single h1 (the active slide's title). -->
  <section *ngIf="unifiedSlides.length" class="uc-hero" [dir]="isRtl ? 'rtl' : 'ltr'"
    aria-roledescription="carousel" [attr.aria-label]="'unifiedHome.hero.label' | translate">
    <div class="uc-hero__viewport" [attr.aria-live]="unifiedPaused ? 'polite' : 'off'">
      <div *ngFor="let item of unifiedSlides; let i = index" class="uc-hero__slide" [class.is-active]="i === unifiedIndex"
        role="group" aria-roledescription="slide" [attr.aria-hidden]="i === unifiedIndex ? null : 'true'"
        [attr.aria-label]="'unifiedHome.hero.slideOf' | translate: { current: i + 1, total: unifiedSlides.length }">
        <img class="uc-hero__image" [src]="getImageUrl(item)" alt="" [attr.loading]="i === 0 ? 'eager' : 'lazy'">
        <div class="uc-hero__overlay" aria-hidden="true"></div>
        <div class="container uc-hero__container">
          <div class="uc-hero__content" [ngStyle]="{ color: getTextColor(item) }">
            <ng-container *ngIf="isRtl ? item.titleAr : item.title">
              <h1 *ngIf="i === unifiedIndex; else inactiveTitle" class="uc-hero__title uc-display-lg uc-semibold">{{ isRtl ? item.titleAr : item.title }}</h1>
              <ng-template #inactiveTitle>
                <h2 class="uc-hero__title uc-display-lg uc-semibold">{{ isRtl ? item.titleAr : item.title }}</h2>
              </ng-template>
            </ng-container>
            <p *ngIf="isRtl ? item.subTitleAr : item.subTitle" class="uc-hero__subtitle uc-text-xl uc-medium">{{ isRtl ? item.subTitleAr : item.subTitle }}</p>
            <p *ngIf="isRtl ? item.detailsAr : item.details" class="uc-hero__description uc-text-lg">{{ isRtl ? item.detailsAr : item.details }}</p>
            <div class="uc-hero__actions">
              <ng-container *ngIf="heroCta(item) as cta">
                <a *ngIf="cta.external; else internalCta" [href]="cta.external" target="_blank" rel="noopener" class="btn uc-btn-primary-on-color"
                  [attr.tabindex]="i === unifiedIndex ? null : -1">{{ cta.label || ('home.startNow' | translate) }}</a>
                <ng-template #internalCta>
                  <a [routerLink]="cta.internal" class="btn uc-btn-primary-on-color"
                    [attr.tabindex]="i === unifiedIndex ? null : -1">{{ cta.label || ('home.startNow' | translate) }}</a>
                </ng-template>
              </ng-container>
              <a routerLink="/course" class="btn uc-btn-secondary-on-color" [attr.tabindex]="i === unifiedIndex ? null : -1" translate="home.learnMore"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="unifiedSlides.length > 1" class="container uc-hero__controls-container">
      <div class="uc-hero__controls">
        <button type="button" class="uc-hero__toggle" (click)="toggleUnifiedAutoplay()"
          [attr.aria-label]="(unifiedPaused ? 'unifiedHome.hero.play' : 'unifiedHome.hero.pause') | translate">
          <i class="fa-solid" [ngClass]="unifiedPaused ? 'fa-play' : 'fa-pause'" aria-hidden="true"></i>
        </button>
        <div class="uc-hero__indicators" role="group" [attr.aria-label]="'unifiedHome.hero.indicators' | translate">
          <button *ngFor="let item of unifiedSlides; let i = index" type="button" class="uc-hero__indicator"
            [class.is-active]="i === unifiedIndex" (click)="goToSlide(i)"
            [attr.aria-current]="i === unifiedIndex ? 'true' : null"
            [attr.aria-label]="'unifiedHome.hero.goToSlide' | translate: { current: i + 1, total: unifiedSlides.length }"></button>
        </div>
      </div>
    </div>
  </section>
} @else {
  <section *ngIf="carouselResize.data?.length">
    <app-custom-carousel #appCustomCarousel [content]="sliderContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event"></app-custom-carousel>
    <div *ngIf="carouselResize.items.length > 1" class="container position-relative">
      <div class="indicator-container position-absolute d-flex align-items-center" [ngClass]="isRtl ? 'justify-content-end' : 'justify-content-start'">
        <div>
          <ng-container *ngFor="let indicator of carouselResize.items; track i; let i = index">
            <span (click)="appCustomCarousel.indicatorSlide(i)" class="indicator" [ngClass]="{'active': carouselResize.currentIndex === i}"></span>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
}
<ng-template #sliderContent>
  <div class="carousel-container position-relative overflow-hidden">
    <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
      <div class="carousel-slide w-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
        <div class="row">
          <div class="col" *ngFor="let item of slide">
            <div class="banner" [ngStyle]="{'background-image': 'url(' + (item.bannerType === 0 ? item.image : homeImageResource + item.image) + ')'}">
              <div class="container d-flex h-100" [ngClass]="item.isRtl ? 'justify-content-start' : 'justify-content-end'">
                <div class="banner-details w-50 align-self-center" [ngStyle]="{ color: getTextColor(item) }">
                  <h1 [dir]="isRtl? 'rtl':'ltr'">{{isRtl ? item.titleAr : item.title}}</h1>
                  <h2 [dir]="isRtl? 'rtl':'ltr'" class="d-flex align-items-center">
                    <span class="text-nowrap">{{isRtl ? getSubTitle(item.subTitleAr) : getSubTitle(item.subTitle)}}</span>
                    <span *ngIf="lastSubTitle !== ''" class="second-sub-title">{{lastSubTitle}}</span>
                  </h2>
                  <p [dir]="isRtl? 'rtl':'ltr'">{{isRtl ? item.detailsAr : item.details}}</p>
                  <div [dir]="isRtl? 'rtl':'ltr'" class="d-flex align-items-center">
                    <a routerLink="/course" class="btn shadow-none d-flex align-items-center justify-content-center text-white" translate="home.startNow"></a>
                    <a routerLink="/course" class="btn shadow-none d-flex align-items-center justify-content-center" translate="home.learnMore"></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>